const CreateAkunSekolahEnty ={
    namaSekolah: null,
    usernameAdmin: null,
    passwordAdmin: null,
    namaKepalaSekolah: null,
    noTelpSekolah: null,
    namaPenanggungJawab: null,
    noTelpPenanggungJawab: null,
    alamatSekolah: null,
    emailSekolah: null,
    idProvinsi: null,
    idKabupatenKota: null,
    idSekolah: null
}

export default CreateAkunSekolahEnty;